export const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    imageUrl: process.env.REACT_APP_IMAGE_URL,
}
